import React, { useEffect } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, AppBar, Toolbar, IconButton } from "@mui/material";

import { Close } from "@mui/icons-material"

interface TypeShowDialog{
    open:boolean;
    title:string;
    msg:string;
    ok(prm?:any):void;
    close():void;
}

export default function ShowDialog(props:TypeShowDialog){
    const { title, msg, open, ok, close } = props;
    
    return(
        <Dialog 
            open={open}
            onClose={close}
            onKeyDown={(ev)=>{
                if(ev.keyCode === 13) {
                    ok()
                }
            }}            
        >
            <AppBar position="static">
                <Toolbar variant="dense">
                <Typography variant="h6" flex={1} color="inherit" component="div">
                    {title}
                </Typography>
                <IconButton onClick={close}  edge="end" color="inherit" title='Esc para cancelar'>
                    <Close />
                </IconButton>
                </Toolbar>
            </AppBar>

            <DialogContent>
                <Typography variant="body1" component="p">{msg}</Typography>
            </DialogContent>
            <DialogActions>
    
                <Button
                    id='btConfirma'
                    variant='contained'
                    onClick={(prm?:any)=>ok(prm)}
                    color="primary"
                    tabIndex={0}
                >
                    Confirma
                </Button>

            </DialogActions>

        </Dialog>
    )
}